/* START BASIC INFORMATION TAB CONST TAB*/
export const initialState = {
  info_type: 'basic_info',
  bk_primary_contact_name: '',
  civil_status: '',
  date_joined: '',
  delivery_address_house_bldg_no: '',
  delivery_address_st_subd_name: '',
  delivery_address_zip_code: '',
  dob: '',
  doctor_id: '',
  father_name: '',
  given_name: '',
  group: '',
  middle_name: '',
  mother_name: '',
  nickname: '',
  present_address_house_bldg_no: '',
  present_address_st_subd_name: '',
  present_address_zip_code: '',
  specialty: '',
  spouse_dob: '',
  spouse_given_name: '',
  spouse_occupation: '',
  spouse_school_hospital: '',
  spouse_specialty: '',
  spouse_surname: '',
  sub_specialty: '',
  surname: '',
  wedding_anniv: '',
  is_same_address: 0,
};

export const childrenState = {
  id: 0,
  given_name: '',
  surname: '',
  middle_name: '',
  dob: '',
  age: '',
  occupation: '',
  specialty: '',
  school_hospital: '',
};
/* END BASIC INFORMATION TAB CONST TAB*/

/* START PROFESSIONAL INFORMATION TAB CONST TAB*/
export const professionalTabDefaultForm = {
  prc_id: '',
  prc_id_issuance_date: '',
  ptr_no: '',
  ptr_no_exp: '',
  cicerone_name: '',
  mobile_primary: '',
  landline: '',
  pref_comm_channel: '',
  email_ad_primary: '',
  email_ad_secondary: '',
  clinics: [],
  hospital_affiliations: [],
  organization_affiliations: [],
};
/* END PROFESSIONAL INFORMATION TAB CONST TAB*/

/* START ENGAGEMENT HISTORY DETAIL TAB CONST TAB*/
export const withAgendaColumn = [
  {
    field: 'schedule',
    headerName: 'Date Schedule',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'date_completed',
    headerName: 'Date Completed',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'program',
    headerName: 'Program',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'total_used',
    headerName: 'Total Used',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
];

export const withoutAgendaColumn = [
  {
    field: 'schedule',
    headerName: 'Date Schedule',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'date_completed',
    headerName: 'Date Completed',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'md_name',
    headerName: 'MD Name',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'moe',
    headerName: 'MOE',
    width: 200,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
];
/* START ENGAGEMENT HISTORY DETAIL TAB CONST TAB*/
